import React from 'react';
import { Route, Routes } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'common/react-query/query-client';
import { getProjectId, getWorkspaceId } from 'common/report/util';
import { ReactErrorBoundary } from 'common/components/react-error-boundary';
import { userCookieUtils } from 'common/report/util/user-identity-from-cookie';
import { FeatureFlagListView } from './components/list';
import { FeatureFlagPage } from './components/page';
import styles from './index.module.styl';
type FeatureFlagProps = {
  projectId: number;
  workspaceId: number;
  userId: number;
};
const List: React.FC<FeatureFlagProps> = _ref => {
  let {
    projectId,
    userId,
    workspaceId
  } = _ref;
  return <FeatureFlagListView projectId={projectId} userId={userId} workspaceId={workspaceId} data-sentry-element="FeatureFlagListView" data-sentry-component="List" data-sentry-source-file="index.tsx" />;
};
const View: React.FC<FeatureFlagProps> = _ref2 => {
  let {
    projectId,
    workspaceId,
    userId
  } = _ref2;
  return <FeatureFlagPage projectId={projectId} workspaceId={workspaceId} userId={userId} data-sentry-element="FeatureFlagPage" data-sentry-component="View" data-sentry-source-file="index.tsx" />;
};

// for lazy loading route
// eslint-disable-next-line import/no-default-export
export default function () {
  var _userCookieUtils$getU, _userCookieUtils$getU2;
  const projectId = parseInt(getProjectId(), 10);
  const workspaceId = parseInt(getWorkspaceId(), 10);
  const userId = (_userCookieUtils$getU = (_userCookieUtils$getU2 = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU2 === void 0 ? void 0 : _userCookieUtils$getU2.id) !== null && _userCookieUtils$getU !== void 0 ? _userCookieUtils$getU : 0;
  return <div className={styles.appContainer}>
      <ReactErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route path='' element={<List projectId={projectId} workspaceId={workspaceId} userId={userId} />} />
            <Route path=':flagId' element={<View projectId={projectId} workspaceId={workspaceId} userId={userId} />} />
          </Routes>
        </QueryClientProvider>
      </ReactErrorBoundary>
    </div>;
}